import { lazy, Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';

const StrategyAudit = lazy(() => import('@/components/StrategyAudit'));
const Services = lazy(() => import('@/components/Services'));
const WhoWeWorkWith = lazy(() => import('@/components/WhoWeWorkWith'));
const Process = lazy(() => import('@/components/Process'));
const About = lazy(() => import('@/components/About'));
const FinalCTA = lazy(() => import('@/components/FinalCTA'));
const Footer = lazy(() => import('@/components/Footer'));

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const tryScroll = (attempts = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (attempts < 20) {
          setTimeout(() => tryScroll(attempts + 1), 150);
        }
      };
      // Small initial delay to allow lazy components to mount
      setTimeout(() => tryScroll(), 100);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <StrategyAudit />
          <Services />
          <WhoWeWorkWith />
          <Process />
          <About />
          <FinalCTA />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
